/**
 * GmNotes - the GM's page of notes, written in play.
 *
 * Drawn only for the seat that has the page (`notes.mine`): the GM, or
 * anyone outside a session. Saved a moment after typing stops and when the
 * field is left; the rules keep it from every other seat.
 *
 * @param {object} props
 * @param {import('../../hooks/useGmNotes').GmNotes} props.notes
 */
import styles from '../../styles/Story.module.css';
import { MAX_NOTES } from '../../hooks/useGmNotes';

export default function GmNotes({ notes }) {
  if (!notes.mine) return null;
  return (
    <section className={styles.section} aria-label="GM notes" data-testid="gm-notes-panel">
      <h3 className={styles.caption}>GM notes</h3>
      <textarea
        className={styles.textarea}
        aria-label="GM notes"
        aria-describedby="gm-notes-hint"
        data-testid="gm-notes"
        placeholder="What only you know."
        value={notes.text}
        maxLength={MAX_NOTES}
        onChange={(e) => notes.setText(e.target.value)}
        onBlur={notes.flush}
      />
      <p className={styles.empty} id="gm-notes-hint">
        Seen by the GM only.
      </p>
    </section>
  );
}
